import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFiles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFiles"><Path d="M7.5 2.5H15.5L20.5 7.5V18.5H7.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 18.5V21.5H4.5V5.5H7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 3V7.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFiles;
